export enum ACCORDION_GROUP_KEYS {
  ECOSSISTEMA = 'ecosystem',
  CONFIGURACOES = 'configs_and_account',
}

export const ACCORDION_DEFAULT_VALUE = [
  ACCORDION_GROUP_KEYS.ECOSSISTEMA,
  ACCORDION_GROUP_KEYS.CONFIGURACOES,
]
